
export const environment = {
  production: false,
  name: "base",
  api: {
    BE: 'https://staging-metafora-ctm.flosslab.com',
    BEVersion: "/api/v1/ctm",
    MeVersion: "/public/v1",
    metafora: 'https://staging-metafora-ctm.flosslab.com/api-metafora/public/v1',
    endpoints: {
      login: '/web/session/authenticate',
      session: '/web/session/get_session_info',
      //Richieste
      hrRequestList: `/hr_request/list`,
      userRequestType: '/hr_request/all_user_request_type/list',
      exercises: '/hr_request/exercise_type/list',
      requests: '/hr_request/request_type/list',
      hrRequest: (id: string ): string => `/hr_request/form/${id}`,
      //Modulo Richiesta
      integrate: '/hr_request/integrate',
      create: '/hr_request/create',
      docstemp: (id: number ): string => `/hr/document/${id}`,

      //Atti Amministrativi
      documentContent: (id: number ) => `/dms_document/download/${id}`,
      procedures: '/administrative_act/list',
      ctmType: '/administrative_act/document_type/list',
      ctmTags: '/administrative_act/tags/list',
      procedure: (id: number ): string => `/administrative_act/form/${id}`,

      //Documenti SGI
      documents: '/ims/document/list',
      documentTypes: '/ims/document/department/list',
      documentDetail: (id: number ): string => `/ims/document/form/${id}`,
    }
  }
};
